if (!customElements.get('slider-component')) {
  customElements.define(
    'slider-component',
    class SliderComponent extends HTMLElement {
      constructor() {
        super();

        this.slider = this.querySelector('[id^="Slider-"]');
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.enableSliderLooping = false;

        this.currentPageElement = this.querySelector(
          '.slider-counter--current'
        );
        this.pageTotalElement = this.querySelector(
          '.slider-counter--total'
        );

        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');

        /*
         * Only stop when the actual slider is missing.
         * Buttons are optional.
         */
        if (!this.slider) return;

        this.initPages();

        const resizeObserver = new ResizeObserver(() => {
          this.initPages();
        });

        resizeObserver.observe(this.slider);

        this.slider.addEventListener(
          'scroll',
          this.update.bind(this),
          { passive: true }
        );

        if (this.prevButton) {
          this.prevButton.addEventListener(
            'click',
            this.onButtonClick.bind(this)
          );
        }

        if (this.nextButton) {
          this.nextButton.addEventListener(
            'click',
            this.onButtonClick.bind(this)
          );
        }
      }

      initPages() {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter(
          (element) => element.clientWidth > 0
        );

        if (this.sliderItemsToShow.length < 1) return;

        if (this.sliderItemsToShow.length === 1) {
          this.sliderItemOffset = this.sliderItemsToShow[0].clientWidth;
          this.slidesPerPage = 1;
          this.totalPages = 1;
          this.currentPage = 1;
          this.updateCounters();
          this.updateButtons();
          return;
        }

        this.sliderItemOffset =
          this.sliderItemsToShow[1].offsetLeft -
          this.sliderItemsToShow[0].offsetLeft;

        if (!this.sliderItemOffset) {
          this.sliderItemOffset =
            this.sliderItemsToShow[0].clientWidth;
        }

        this.slidesPerPage = Math.max(
          1,
          Math.floor(
            (
              this.slider.clientWidth -
              this.sliderItemsToShow[0].offsetLeft
            ) / this.sliderItemOffset
          )
        );

        this.totalPages = Math.max(
          1,
          this.sliderItemsToShow.length -
            this.slidesPerPage +
            1
        );

        this.update();
      }

      resetPages() {
        this.sliderItems =
          this.querySelectorAll('[id^="Slide-"]');

        this.initPages();
      }

      update() {
        if (
          !this.sliderItemsToShow ||
          this.sliderItemsToShow.length === 0 ||
          !this.sliderItemOffset
        ) {
          return;
        }

        const previousPage = this.currentPage;

        this.currentPage =
          Math.round(
            this.slider.scrollLeft /
              this.sliderItemOffset
          ) + 1;

        this.currentPage = Math.min(
          Math.max(this.currentPage, 1),
          this.totalPages
        );

        this.updateCounters();

        if (
          this.currentPage !== previousPage &&
          this.sliderItemsToShow[
            this.currentPage - 1
          ]
        ) {
          this.dispatchEvent(
            new CustomEvent('slideChanged', {
              detail: {
                currentPage: this.currentPage,
                currentElement:
                  this.sliderItemsToShow[
                    this.currentPage - 1
                  ]
              }
            })
          );
        }

        this.updateButtons();
      }

      updateCounters() {
        if (
          this.currentPageElement &&
          this.pageTotalElement
        ) {
          this.currentPageElement.textContent =
            this.currentPage || 1;

          this.pageTotalElement.textContent =
            this.totalPages || 1;
        }
      }

      updateButtons() {
        if (this.enableSliderLooping) return;

        const firstSlide =
          this.sliderItemsToShow?.[0];

        const lastSlide =
          this.sliderItemsToShow?.[
            this.sliderItemsToShow.length - 1
          ];

        if (this.prevButton && firstSlide) {
          if (
            this.isSlideVisible(firstSlide) &&
            this.slider.scrollLeft <= 1
          ) {
            this.prevButton.setAttribute(
              'disabled',
              'disabled'
            );
          } else {
            this.prevButton.removeAttribute('disabled');
          }
        }

        if (this.nextButton && lastSlide) {
          if (this.isSlideVisible(lastSlide)) {
            this.nextButton.setAttribute(
              'disabled',
              'disabled'
            );
          } else {
            this.nextButton.removeAttribute('disabled');
          }
        }
      }

      isSlideVisible(element, offset = 0) {
        if (!element) return false;

        const lastVisibleSlide =
          this.slider.clientWidth +
          this.slider.scrollLeft -
          offset;

        return (
          element.offsetLeft + element.clientWidth <=
            lastVisibleSlide &&
          element.offsetLeft >= this.slider.scrollLeft
        );
      }

      onButtonClick(event) {
        event.preventDefault();

        if (!this.sliderItemOffset) return;

        const step =
          Number(event.currentTarget.dataset.step) || 1;

        const direction =
          event.currentTarget.name === 'next'
            ? 1
            : -1;

        const slideScrollPosition =
          this.slider.scrollLeft +
          direction *
            step *
            this.sliderItemOffset;

        this.slider.scrollTo({
          left: slideScrollPosition,
          behavior: 'smooth'
        });
      }
    }
  );
}